import { Dispatch } from 'vuex';
import { IState } from '@app/store';
import filter from '@app/store/modules/ui/shared/lotto/filter/filterIndex.ts';
import { routeNames } from '@src/app/router/constants';
import LottoEvent from '@core/models/lotto/LottoEvent';

const lottoFilterModule = filter({
    baseLotteryRoute: routeNames.lottoResults,
    lotteryFilterRoute: routeNames.lottoGameResults,
    lotterySystemRoute: routeNames.lottoSystemResults,
    eventsGetter: 'data/results/lotto/results',
    selectedEventGetter: 'ui/results/expandedEventId'
});

export default (parentStorePath: string) => ({
    namespaced: true,
    state: lottoFilterModule.state,
    mutations: lottoFilterModule.mutations,
    getters: {
        selectedDate(state: any, getters: any, rootState: IState, rootGetters: any) {
            return rootGetters[`${parentStorePath}/selectedDate`];
        },
        ...lottoFilterModule.getters,
        // TODO maybe delete. Not sure it's used
        timeFilter(state: any, getters: any, rootState: IState, rootGetters: any) {
            const [startDate, endDate] = rootGetters[`${parentStorePath}/timeWindow`];
            return {
                getFilter: () => (event: LottoEvent) => (
                    event.date >= startDate
                    && event.date < endDate
                ),
            };
        }
    },
    actions: {
        toggleExpandedEventId: (
            { dispatch }: { dispatch: Dispatch },
            eventId: number
        ) => {
            dispatch(`${parentStorePath}/toggleExpandedEventId`, eventId, { root: true });
        },
        ...lottoFilterModule.actions,
    }
});



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/store/modules/ui/results/lotto.ts